<kui-input-group [cleanAddons]="true" class="w-100 d-block">
    <kui-tag-input
        [invalid]="error || (field.required && dirty && touched && selectedItems().length === 0)"
        [placeholder]="'FORMS.ZONEFILTER.PLACEHOLDER' | translate"
        [loading]="isLoading"
        [autoCompleteItems]="autoCompleteItems"
        [remoteSearch]="true"
        [selectedItems]="selectedItems()"
        (itemAdded)="addTag($event)"
        (itemRemoved)="removeTag($event)"
        (searchTermChanged)="updateAutoCompletionList($event)"
        [multiple]="field.max !== 1"
    ></kui-tag-input>
    <span kui-input-group-addon class="p-0" [class.border-danger]="error || (field.required && dirty && touched && selectedItems().length === 0)" [class.overlay]="overlay">
        <kui-dropdown [style]="'none'" [customContent]="dropdownContent" [customContentContext]="dropdownContext" (onOpen)="overlay = true" (onClose)="overlay = false">
            <kui-icon [name]="field.max === 1 ? 'chevron-down' : 'plus'" size="xs" class="py-2 px-3"></kui-icon>
        </kui-dropdown>
        <ng-template #dropdownContent let-component="component" let-tree="tree">
            <div style="min-width: 200px">
                @if (!treeNodes?.length) {
                    <p class="px-3 mb-0">
                        {{ "SHARED.NO_RESULTS_FOUND" | translate }}
                    </p>
                }
                @if (truncatedList) {
                    <p class="trucated-message mb-0">
                        {{ "FORMS.SEARCHSELECT.TRUNCATED_MESSAGE" | translate: truncatedList }}
                    </p>
                }
                <kui-tree-select [nodes]="treeNodes" (selectedNodeChanged)="nodeSelected($event, component, tree)"></kui-tree-select>
            </div>
        </ng-template>
    </span>
</kui-input-group>

@if (field.required && dirty && touched && selectedItems().length === 0) {
    <div class="invalid-feedback d-block">
        <div>{{ "FORMS.SHARED.REQUIRED" | translate: { field: field.title } }}</div>
    </div>
}
@if (error) {
    <div class="invalid-feedback d-block">
        <div>{{ error }}</div>
    </div>
}
